import React from 'react';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';

const LoadingSpinner = ({ size = 'md', className = '', color = 'primary', theme }) => {
  // Theme resolution:
  // 1. Explicit `theme` prop ('admin' | 'employee') always wins — used by theme-aware
  //    modals that already know their context (e.g. an HR-facing modal on an employee route).
  // 2. Otherwise fall back to the route: /admin and /asset-admin use the HR/admin (red)
  //    theme, everything else uses the employee (blue) theme. This mirrors the rest of
  //    the app's route-based theming (the `-admin` suffixed classes in index.css).
  const { pathname } = useLocation();
  const isAdminTheme = theme
    ? theme === 'admin'
    : pathname.startsWith('/admin') || pathname.startsWith('/asset-admin');

  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  };

  // 'primary' follows the active theme (employee = blue, HR/admin = red) and matches
  // the DS `.loading-spinner` / `.loading-spinner-admin` classes. 'white' and 'gray'
  // remain explicit overrides for use on colored backgrounds (e.g. buttons).
  const colorClasses = {
    primary: isAdminTheme ? 'border-t-red-600' : 'border-t-blue-600',
    white: 'border-t-white',
    gray: 'border-t-gray-600',
  };

  return (
    <div className={clsx('flex items-center justify-center', className)}>
      <div
        className={clsx(
          'animate-spin rounded-full border-2 border-gray-300',
          sizeClasses[size],
          colorClasses[color]
        )}
      />
    </div>
  );
};

export default LoadingSpinner;
